/* tslint:disable */
/* eslint-disable */
/**
 * TOM OPERATIONS SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded,
} from '../common'
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap,
} from '../base'
// @ts-ignore
import type { CreateStoppageCommand } from '../model'
// @ts-ignore
import type { StoppageResponseDto } from '../model'
// @ts-ignore
import type { UpdateStoppageCommand } from '../model'
/**
 * StoppagesApi - axios parameter creator
 */
export const StoppagesApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('_delete', 'id', id)
      const localVarPath = `/operations/api/Stoppages/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {CreateStoppageCommand} [createStoppageCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create: async (
      createStoppageCommand?: CreateStoppageCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Stoppages`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        createStoppageCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get: async (
      carrierVisitId?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Stoppages`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      if (carrierVisitId !== undefined) {
        localVarQueryParameter['CarrierVisitId'] = carrierVisitId
      }

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getById: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('getById', 'id', id)
      const localVarPath = `/operations/api/Stoppages/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {UpdateStoppageCommand} [updateStoppageCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update: async (
      updateStoppageCommand?: UpdateStoppageCommand,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/operations/api/Stoppages`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication Bearer required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, 'Bearer', [], configuration)

      localVarHeaderParameter['Content-Type'] = 'application/json'
      localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        updateStoppageCommand,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * StoppagesApi - functional programming interface
 */
export const StoppagesApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = StoppagesApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _delete(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator._delete(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StoppagesApi._delete']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {CreateStoppageCommand} [createStoppageCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      createStoppageCommand?: CreateStoppageCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        createStoppageCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StoppagesApi.create']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StoppageResponseDto>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(carrierVisitId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StoppagesApi.get']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getById(
      id: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoppageResponseDto>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StoppagesApi.getById']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {UpdateStoppageCommand} [updateStoppageCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      updateStoppageCommand?: UpdateStoppageCommand,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(
        updateStoppageCommand,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['StoppagesApi.update']?.[localVarOperationServerIndex]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * StoppagesApi - factory interface
 */
export const StoppagesApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = StoppagesApiFp(configuration)
  return {
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp._delete(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {CreateStoppageCommand} [createStoppageCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      createStoppageCommand?: CreateStoppageCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .create(createStoppageCommand, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} [carrierVisitId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      carrierVisitId?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<StoppageResponseDto>> {
      return localVarFp.get(carrierVisitId, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getById(id: number, options?: RawAxiosRequestConfig): AxiosPromise<StoppageResponseDto> {
      return localVarFp.getById(id, options).then(request => request(axios, basePath))
    },
    /**
     *
     * @param {UpdateStoppageCommand} [updateStoppageCommand]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      updateStoppageCommand?: UpdateStoppageCommand,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<number> {
      return localVarFp
        .update(updateStoppageCommand, options)
        .then(request => request(axios, basePath))
    },
  }
}

/**
 * StoppagesApi - object-oriented interface
 */
export class StoppagesApi extends BaseAPI {
  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public _delete(id: number, options?: RawAxiosRequestConfig) {
    return StoppagesApiFp(this.configuration)
      ._delete(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {CreateStoppageCommand} [createStoppageCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public create(createStoppageCommand?: CreateStoppageCommand, options?: RawAxiosRequestConfig) {
    return StoppagesApiFp(this.configuration)
      .create(createStoppageCommand, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [carrierVisitId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public get(carrierVisitId?: number, options?: RawAxiosRequestConfig) {
    return StoppagesApiFp(this.configuration)
      .get(carrierVisitId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getById(id: number, options?: RawAxiosRequestConfig) {
    return StoppagesApiFp(this.configuration)
      .getById(id, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {UpdateStoppageCommand} [updateStoppageCommand]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public update(updateStoppageCommand?: UpdateStoppageCommand, options?: RawAxiosRequestConfig) {
    return StoppagesApiFp(this.configuration)
      .update(updateStoppageCommand, options)
      .then(request => request(this.axios, this.basePath))
  }
}
